import { useRef } from "react";
import { motion, useScroll, useTransform } from "framer-motion";
import { MaskedLine, Overline } from "@/components/motion";

export const PageHero = ({ image, alt, overline, titleLines, subtitle, testid }) => {
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({
    target: ref,
    offset: ["start start", "end start"],
  });
  const y = useTransform(scrollYProgress, [0, 1], [0, 180]);

  return (
    <section
      ref={ref}
      data-testid={testid}
      className="relative flex h-[72vh] min-h-[540px] items-end overflow-hidden"
    >
      <motion.div style={{ y }} className="absolute inset-0">
        <motion.img
          src={image}
          alt={alt}
          initial={{ scale: 1.15 }}
          animate={{ scale: 1 }}
          transition={{ duration: 2.2, ease: [0.22, 1, 0.36, 1] }}
          className="h-full w-full object-cover"
        />
      </motion.div>
      <div className="absolute inset-0 bg-gradient-to-t from-abyss via-abyss/40 to-transparent" />

      <div className="relative z-10 mx-auto w-full max-w-[1440px] px-6 pb-16 lg:px-12 lg:pb-24">
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.3, duration: 0.8 }}
        >
          <Overline className="mb-6">{overline}</Overline>
        </motion.div>
        <h1 className="font-serif text-4xl font-light leading-[1.05] tracking-tight text-ivory sm:text-5xl lg:text-6xl">
          {titleLines.map((line, i) => (
            <MaskedLine key={i} delay={0.35 + i * 0.15}>
              {line}
            </MaskedLine>
          ))}
        </h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: 0.9, duration: 0.8 }}
            className="mt-6 max-w-xl text-base leading-relaxed text-ivory/70"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
};
